import Heading, { HeadingLevels } from '@/components/atoms/legacy/Heading';
import Link from '@/components/atoms/legacy/Link';
import { ResponsiveMargin } from '@/components/atoms/legacy/ResponsiveMargin/ResponsiveMargin';

interface SitemapLink {
  displayName: string;
  href: string;
  dangerous?: boolean;
}

interface CategorySectionProps {
  categoryName?: string;
  wrap?: boolean;
  links: SitemapLink[];
}

const CategorySection: React.FC<CategorySectionProps> = ({
  wrap = true,
  categoryName,
  links,
}) => {
  return (
    <div>
      {categoryName ? (
        <Heading level={HeadingLevels.H2} className="pb-m text-h3Regular">
          {categoryName}
        </Heading>
      ) : null}
      <ul
        className={`${
          links.length >= 4 && wrap ? 'columns-1 m:columns-2 l:columns-4' : ''
        } l:max-w-[1200px]`}
      >
        {links.map((link) => (
          <li key={link.href} className="pb-s">
            <Link
              href={link.href}
              className="text-body1Regular text-blue-medium"
            >
              {link.dangerous ? (
                <div dangerouslySetInnerHTML={{ __html: link.displayName }} />
              ) : (
                <div>{link.displayName}</div>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export interface SitemapTemplateProps {
  title: string;
  categories: CategorySectionProps[];
}

const SitemapTemplate: React.FC<SitemapTemplateProps> = ({
  title,
  categories,
}) => {
  return (
    <ResponsiveMargin>
      <div className="py-3xl">
        <Heading level={HeadingLevels.H1} className="pb-xl text-h2SemiBold">
          {title}
        </Heading>

        <div className="flex flex-col gap-xl">
          {categories.map((category) => (
            <CategorySection key={category.categoryName} {...category} />
          ))}
        </div>
      </div>
    </ResponsiveMargin>
  );
};

export default SitemapTemplate;
